<section class="mm-expansion">
  <div class="mm-expansion-header" (click)="toggleExpand()" [mmTestTarget]="testTarget"
       role="button"
       tabindex="0"
       [attr.aria-expanded]="expanded">

    <ng-content select="mm-expansion-title"></ng-content>

    <div [ngClass]="{
            'expanded': expanded,
            'mm-expansion-header__toggler': true,
            'mm-expansion-header__toggler--left': togglerPosition === 'left',
            'mm-expansion-header__toggler--arrow': arrowToggler,
            'mm-expansion-header__toggler--plus': !arrowToggler,
            'mm-expansion-header__toggler--hidden': disableToggle
          }"
    ></div>
  </div>

  <div class="mm-expansion-content" [@toggleExpand]="expanded" [@.disabled]="disableAnimation">
    <ng-content></ng-content>
  </div>
</section>
